/* eslint-disable padding-line-between-statements */
import React, { useCallback, useContext, useEffect, useState } from 'react'
import _ from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import './TFPAConstructionDetails.messages';
import metadata from './TFPAConstructionDetails.metadata.json5';

function TFPAConstructionDetails(props) {
    const { submissionVM, updateWizardData, showErrors, findInvalidComponent, steps, onValidate } = props;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);

    const[constructionTypeValues, setConstructionTypeValues] = useState([]);
    const policyTypeCode = submissionVM.lobData.homeowners_tfpa.policyType_TWIA.value.code;
    // const policyTypeCode = submissionVM.lobData.homeowners_tfpa.coverables?.construction?.policyType_Ext?.value?.code;
    const { refreshData } = useDataRefresh();
    
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('TFPAConstructionDetails');
   
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'TFPAConstructionDetails');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, 'TFPAConstructionDetails');
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        setConstructionValues_TFPA();
    }, [])

    const filterConstructionTypeTFPA = useCallback(() => {
        const availableConstructionType = submissionVM.lobData.homeowners_tfpa.coverables.construction.constructionType?.aspects.availableValues;
        if (availableConstructionType && availableConstructionType.length > 0) {
            const constructionTypeList = availableConstructionType.map((code) => {
                return {
                    code: code.code,
                    name: translator({ id: code.name })
                }
            })
            setConstructionTypeValues(constructionTypeList)
        }
    }, [submissionVM, translator])
    
    const setConstructionValues_TFPA = useCallback(() => {
        filterConstructionTypeTFPA();
        updateWizardData(submissionVM);
    }, []);

    const handleChangeConstructionType = useCallback((value, path) => {
        const prevSelection = submissionVM.lobData.homeowners_tfpa.coverables.construction.constructionType.value?.code;
       if (value !== prevSelection){
           // clear out the original values entered for construction.
           if (prevSelection === 'MH_ext'){
            // clear out mobile home related items..
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.mobileHomeUnitBlocked_ext.value', undefined);
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.mobileHomeLength_ext.value', undefined);
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.mobileHomeWidth_ext.value', undefined);
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.mobileHomeMake_ext.value', undefined);
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.mobileHomeModel_ext.value', undefined);
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.mobileHomeSerialNumber_ext.value', undefined);
           }
          _.set(submissionVM.value, path, value);
       }
       updateWizardData(submissionVM);     
    }, []);


    const handleChangeFoundationType = useCallback((value, path) => {
        const prevSelection = submissionVM.lobData.homeowners_tfpa.coverables.construction.foundationType.value?.code;
       if (value !== prevSelection){
           // clear out the original values entered for construction.
           if (prevSelection === 'FullBasement'){
            // clear out mobile home related items..
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.basementFinishedArea.value', undefined);
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.basementUnfinishedArea.value', undefined);
           }
          _.set(submissionVM.value, path, value);
       }
       updateWizardData(submissionVM);     
    }, []);

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true
        },
        yearBuilt: {
            visible: true,
            minYear: [1600]
        },
        conditionofDwelling: {
            visible: policyTypeCode ==='HO6' || policyTypeCode === 'HO3' || policyTypeCode === 'DP2'
        },
        constructionType: {
            visible: true,
            availableValues: constructionTypeValues
        },
        isUnitTiedDownContainer:{
            visible: (policyTypeCode === 'DP2' || policyTypeCode === 'HO3') && submissionVM.lobData.homeowners_tfpa.coverables.construction.constructionType?.value?.code === 'MH_ext'
        },
        numberofStories: {
            visible: policyTypeCode ==='HO6' || policyTypeCode === 'HO3' || policyTypeCode === 'DP2'
        },
        livingArea: {
            visible: true,
            decimalPlaces: 0
        },
        garage: {
            visible: policyTypeCode ==='HO6' || policyTypeCode === 'HO3' || policyTypeCode === 'DP2'
        },
        width: {
            decimalPlaces: 0
        },
        length: {
            decimalPlaces: 0
        },
        foundationType: {
            visible: policyTypeCode === 'HO3' || policyTypeCode === 'DP2',
            required: policyTypeCode === 'DP2' || policyTypeCode === 'HO3'
        },
        basementContainer: {
            visible: (policyTypeCode === 'DP2' || policyTypeCode === 'HO3') && submissionVM.lobData.homeowners_tfpa.coverables.construction.foundationType?.value?.code === 'FullBasement'
        },
        basementAreaFinished:{
            decimalPlaces: 0
        },
        basementAreaUnFinished:{
            decimalPlaces: 0
        }
    }

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            updateWizardData(submissionVM);
            refreshData();
        }, [refreshData, submissionVM, updateWizardData]
    );

    const resolvers = {
        resolveCallbackMap: {
            handleChangeConstructionType,
            handleChangeFoundationType
        },
        // resolveClassNameMap: styles
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={submissionVM}
            showErrors={showErrors}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    )
}

export default TFPAConstructionDetails;
